export default __webpack_public_path__ + "static/media/GoogleSvg.efa560d3.svg";